
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NoticiaQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modulo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uf"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ufs_favoritos"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"noticias"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"modulo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modulo"}}},{"kind":"Argument","name":{"kind":"Name","value":"canal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canal"}}},{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"uf"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uf"}}},{"kind":"Argument","name":{"kind":"Name","value":"ativo"},"value":{"kind":"StringValue","value":"1","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Noticia"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"conteudo"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"dataExpiracao"},"name":{"kind":"Name","value":"data_expiracao"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data_publicacao"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hora_publicacao"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"informe"},"name":{"kind":"Name","value":"informe_comercial"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"falandoDeGente"},"name":{"kind":"Name","value":"falando_de_gente"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lido"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"confirmado_falando_de_gente"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vigencia"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leitura_obrigatoria"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prazo_leitura"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dias_restantes"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"publicadoPor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"nome"},"name":{"kind":"Name","value":"us_nome"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"descricao"},"name":{"kind":"Name","value":"tag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"favorita"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"canal"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"canal"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"uf"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ufs_favoritos"}}}],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":819}};
    doc.loc.source = {"body":"#import \"../fragments/Noticia.gql\"\n\nquery NoticiaQuery($modulo: String!, $canal: Int, $slug: String, $uf: [String], $ufs_favoritos: [Int]) {\n  noticias(\n    modulo: $modulo\n    canal: $canal\n    slug: $slug\n    uf: $uf\n    ativo: \"1\"\n  ) {\n    data {\n      ...Noticia\n      #lg: imagem(resolucao: \"980x530\")\n      #md: imagem(resolucao: \"660x371\")\n      conteudo\n      dataExpiracao: data_expiracao\n      data_publicacao\n      hora_publicacao\n      informe: informe_comercial\n      falandoDeGente: falando_de_gente\n      lido\n      confirmado_falando_de_gente\n      vigencia\n      leitura_obrigatoria\n      prazo_leitura\n      dias_restantes\n      user: publicadoPor {\n        nome: us_nome\n      }\n      tags {\n        descricao: tag\n        slug\n      }\n      favorita(canal: [$canal] uf: $ufs_favoritos)\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/Noticia.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["NoticiaQuery"] = oneQuery(doc, "NoticiaQuery");
        
